export default function (store, { id, groupMode }) {
    const { selected: stateSelected, search } = store.getState();
    if (id) {
        let selected = null;
        if (groupMode) {
            selected = stateSelected ? [...stateSelected] : [];
            if (selected.includes(id)) {
                store.in.exec("unselect-card", {
                    id: id,
                });
                return;
            }
            else {
                selected.push(id);
            }
        }
        else {
            selected = [id];
        }
        if (search) {
            store.in.exec("set-search", { value: null });
        }
        store.setState({ selected });
        if (selected.length > 1) {
            store.in.exec("set-edit", null);
        }
        else {
            store.in.exec("set-edit", { cardId: id });
        }
    }
}
//# sourceMappingURL=select.js.map